import React from "react";
import { technologies } from "../../../data/technologies";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import "./styles.css";

const Project = ({ project }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="project-container" onClick={() => navigate(`/projects/${project.slug}`)}>
      <div className="project-image-container">
        <img src={`${project.assetFolder}${project.assetLogo}`} alt={t(project?.titleKey)} />
      </div>

      <div className="project-title-container">
        <span>{t(project.titleKey)}</span>
      </div>

      <div className="project-title-tecnologies-container">
        {project.techs.map((techKey, index) => {
          const tech = technologies.find((t) => t.key === techKey);
          return tech ? (
            <img
              key={`${project.slug}-${techKey}-${index}`}
              src={`/assets/technologies/${tech.icon}`}
              alt={tech.name}
              title={tech.name}
              style={{ height: 18, width: "auto" }}
            />
          ) : null;
        })}
      </div>

      <div className="project-about-container">
        <p>{t("projects.about")}</p>
        <span>{t(project?.shortDescriptionKey)}</span>
      </div>
    </div>
  );
};

export default Project;
